import React, { Component } from 'react';
import axios from 'axios'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { Form, Segment, Button, Divider, } from 'semantic-ui-react'
import { SingleDatePicker } from 'react-dates';
import * as UiConsts from '../../../../config/UiConstants';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class TinNumberAddCustomer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            tinNumber:''
        }
    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("actn1 e.target.name:" + e.target.name);
        console.log("actn1 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }


    addCustomerTin = () => {
        console.log("actn12++++++++:markDeliveryDate");
        console.log("actn13 this.props.customerId:" + this.props.customerId)
        console.log("actn14 this.state.tinNumber:" + this.props.tinNumber)
        console.log("actn15 this.props.user.email:" + this.props.user.email)

        if (this.props.customerId == '') {
            alert("No customerId Person")
        } else if (this.props.user.email == '') {
            alert("No Entered By Provided")
        } else if (this.state.tinNumber == '') {
            alert("No tinNumber Selected")
        } else {
            console.log("sending addCustomerTin data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'addCustomerTin', {
                apiKey: "dfatB@asdf",
                customerId: this.props.customerId,
                enteredBy: this.props.user.email,
                tinNumber: this.state.tinNumber
            })
                .then((response) => {
                    this.setState({
                        loading: false
                    })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. tin number added ");

                        this.setState({
                            tinNumber: ''
                        })

                        alert(response.data.message);
                        //istory.push("/dashboard/viewLargeProject/" + this.props.projectId);
                    } else {
                        console.log("FAILED");
                        this.setState({ loading: false });
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    render() {

        const setTinNumberButton = this.state.tinNumber != '' && this.state.tinNumber.length > 8
            ? <Button color='violet'>SET TIN NUMBER</Button>
            : ''


        const enterTinNumber =
            <div>
                <Divider horizontal>{'ADD TIN NUMBER'}</Divider>

                <Form size='large' onSubmit={this.addCustomerTin}>
                    
                        <h3>ENTER TIN NUMBER</h3>
                        <label>Enter TIN NUMBER</label>
                        <Form.Input
                            fluid
                            icon='money'
                            iconPosition='left'
                            placeholder='Tin Number'
                            type='text'
                            name="tinNumber"
                            value={this.state.tinNumber}
                            onChange={this.handleTextInputChange}
                        />

                        {setTinNumberButton}
                   
                </Form>
            </div>


        return (this.state.loading ? <UiConsts.LoadingComponent /> : 
        <div>
            <Segment>
            {enterTinNumber}
            </Segment>
          
   
        </div>);
    }
}

export default TinNumberAddCustomer;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/TinNumberAddCustomer.js